<script>
  import { onMount } from 'svelte';
  import { t9n } from '../lib/translate.js';
  import { TS } from '../config/translation-keys.js';
  import { show_message } from '../lib/flash.ts';
  import session from '../lib/session';
  import APIClient from '../state-charts/api-client';
  import Selector from '../lib/components/Selector.svelte';
  import InputWithDate from '../lib/components/InputWithDate.svelte';
  import InputWithValidation from '../lib/components/InputField.svelte';
  import DatePicker from '../lib/components/DatePicker.svelte';


  // component options  ------------------------------------------------------ //

  export let route_name;

  // translated strings ------------------------------------------------------ //

  const reports_text = t9n(TS.ORDERER_REPORTS_REPORT_TEXT);
  const report_label = t9n(TS.WORKER_REPORTS_REPORT_INPUT_TITLE);
  const creation_date_label = t9n(TS.ORDERER_REPORTS_CREATION_DATE_LABEL);
  const completion_date_label = t9n(TS.ORDERER_REPORTS_COMPLETION_DATE_LABEL);
  const filter_by_label = t9n(TS.ORDERER_REPORTS_FILTER_BY_LABEL);
  const file_type_label = t9n(TS.ORDERER_REPORTS_FILE_TYPE_LABEL);
  const period_label = t9n(TS.ORDERER_REPORTS_PERIOD_LABEL);
  const from_date_label = t9n(TS.ORDERER_REPORTS_FROM_DATE_LABEL);
  const to_date_label = t9n(TS.ORDERER_REPORTS_TO_DATE_LABEL);
  const button_in_progress_text = t9n(
    TS.ORDERER_REPORTS_BUTTON_IN_PROGRESS_TEXT
  );
  const button_text = t9n(TS.ORDERER_REPORTS_BUTTON_TEXT);
  const select_type_text = t9n(TS.ORDERER_REPORTS_SELECT_TYPE_TEXT);
  const no_date_type_error = t9n(TS.ORDERER_REPORTS_NO_DATE_TYPE_ERROR);
  const no_file_type_error = t9n(TS.ORDERER_REPORTS_NO_FILE_TYPE_ERROR);
  const no_order_state_error = t9n(TS.ORDERER_REPORTS_NO_ORDER_STATE_ERROR);

  // internal variables ------------------------------------------------------ //

  const date_types = [
    { val: 'created_at', name: creation_date_label },
    { val: 'completion_date', name: completion_date_label },
  ];
  const file_types = [
    { val: 'csv', name: 'csv' },
    { val: 'xls', name: 'xls' },
  ];
  let order_states = [
    {
      status: 'order_status_initialized',
      name: t9n('order_status_initialized'),
      checked: true,
    },
    {
      status: 'order_status_in_progress',
      name: t9n('order_status_in_progress'),
      checked: true,
    },
    {
      status: 'order_status_delivered',
      name: t9n('order_status_delivered'),
      checked: true,
    },
    {
      status: 'order_status_not_approved',
      name: t9n('order_status_not_approved'),
      checked: true,
    },
    {
      status: 'order_status_completed',
      name: t9n('order_status_completed'),
      checked: true,
    },
    {
      status: 'order_status_cancelled_by_worker',
      name: t9n('order_status_cancelled_by_worker'),
      checked: true,
    },
    {
      status: 'order_status_cancelled_by_orderer',
      name: t9n('order_status_cancelled_by_orderer'),
      checked: true,
    },
    {
      status: 'order_status_cancelled_by_admin',
      name: t9n('order_status_cancelled_by_admin'),
      checked: true,
    },
  ];
  let merchant = '';
  let date_from = new Date().toISOString().substr(0, 10);
  let date_to = new Date().toISOString().substr(0, 10);
  let date_type = null;
  let file_type = null;
  const selected_states = () => {
    return order_states
      .map(s => {
        if (s.checked) return s.status;
      })
      .filter(s => {
        if (s) return s;
      });
  };
  let loading = false;
  let not_checked = false;

  $: merchant = $session.merchant.service.selection_name;
  $: {
    order_states = [
      {
        status: 'order_status_initialized',
        name: t9n('order_status_initialized'),
        checked: true,
      },
      {
        status: 'order_status_in_progress',
        name: t9n('order_status_in_progress'),
        checked: true,
      },
      {
        status: 'order_status_delivered',
        name: t9n('order_status_delivered'),
        checked: true,
      },
      {
        status: 'order_status_not_approved',
        name: t9n('order_status_not_approved'),
        checked: true,
      },
      {
        status: 'order_status_completed',
        name: t9n('order_status_completed'),
        checked: true,
      },
      {
        status: 'order_status_cancelled_by_worker',
        name: t9n('order_status_cancelled_by_worker'),
        checked: true,
      },
      {
        status: 'order_status_cancelled_by_orderer',
        name: t9n('order_status_cancelled_by_orderer'),
        checked: true,
      },
      {
        status: 'order_status_cancelled_by_admin',
        name: t9n('order_status_cancelled_by_admin'),
        checked: true,
      },
    ];
  }

  // utility functions -------------------------------------------------------- //

  const download_file = (url, name) => {
    const link = document.createElement('a');
    link.download = name;
    link.href = url;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const validate = () => {
    if (!date_type) {
      show_message(no_date_type_error, 'error');
      return false;
    }

    if (!file_type) {
      show_message(no_file_type_error, 'error');
      return false;
    }

    let comma_separated_statuses = selected_states().join(',');

    if (!comma_separated_statuses) {
      show_message(no_order_state_error, 'error');
      return false;
    }

    return true;
  };

  const submit_form = async () => {
    if (!validate()) return false;

    loading = true;

    let comma_separated_statuses = selected_states().join(',');
    let data = {
      date_type,
      date_from,
      date_to,
      comma_separated_statuses,
    };

    try {
      const response = await APIClient.get_orderer_report_url(data, file_type);
      download_file(response.url, `report.${file_type}`);
    } catch (error) {
      show_message(error, 'error');
    }
    loading = false;
  };

  const init = () => {
    document.querySelector('.mdc-top-app-bar--fixed-adjust').scrollIntoView({behavior: "smooth"})
    merchant = $session.merchant.service.selection_name;
  };

  onMount(init);
</script>

    <form class="reports-form" id="reports_form">
      <!-- Headline -->
      <div style="text-align: center;">
        <h1 style="margin-bottom: 35px" class="mdc-typography--headline5">
          {reports_text}
        </h1>
      </div>

      <!-- Merchant -->
      <div class="mdc-text-field--disabled">
        <InputWithValidation
          id="merchant"
          margin_bottom={'1px'}
          type='text'
          label={report_label}
          name="merchant"
          value={merchant}
          disabled={true}
          width='100%' />
      </div>

      <!-- Filter by -->
      <div
        class="native-sel-width"
        style="margin-top: 16px; margin-bottom: 16px;">
        <Selector
          id="filter_selector"
          label={filter_by_label}
          items={date_types}
          bind:value={date_type} />
      </div>

      <!-- Period -->
      <div style="margin-top: 3px; display: flex; flex-wrap: wrap">
        <div
          id="for-mobile-input"
          style="position: relative; margin-right: 10px;">
          <DatePicker
            id='period-from'
            label={`${period_label} ${from_date_label.toLowerCase()}`}
            bind:value={date_from}
            min='2014-01-01'
            is_end_date={true}
            max={date_to} />

<!--          <InputWithDate-->
<!--            id='period-from'-->
<!--            label={`${period_label} ${from_date_label.toLowerCase()}`}-->
<!--            bind:value={date_from}-->
<!--            name="date_from"-->
<!--            min='2014-01-01'-->
<!--            max={date_to}/>-->
        </div>

        <div style="position: relative">
          <DatePicker
            id='period-to'
            label={`${period_label} ${to_date_label.toLowerCase()}`}
            bind:value={date_to}
            min={date_from}
            is_end_date={true}
            max={new Date().toISOString().substr(0, 10)} />

<!--          <InputWithDate-->
<!--            id='period-to'-->
<!--            label={`${period_label} ${to_date_label.toLowerCase()}`}-->
<!--            bind:value={date_to}-->
<!--            name="date_to"-->
<!--            min={date_from}-->
<!--            max={new Date().toISOString().substr(0, 10)}/>-->
        </div>
      </div>

      <!-- Status -->
      <div style="margin-top: 7px;">
        {#each order_states as state}
          <div
            class="mdc-checkbox"
            style="width: 100%; margin-bottom: -9px">
            <input
              type="checkbox"
              class="mdc-checkbox__native-control"
              id={state.status}
              bind:checked={state.checked} />

            <div class="mdc-checkbox__background">
              <svg class="mdc-checkbox__checkmark" viewBox="0 0 24 24">
                <path
                  class="mdc-checkbox__checkmark-path"
                  fill="none"
                  d="M1.73,12.91 8.1,19.28 22.79,4.59" />
              </svg>

              <div class="mdc-checkbox__mixedmark" />
            </div>

            <label
              class="checkbox-label"
              style="text-align: left;"
              for={state.status}>
              {state.name}
            </label>
          </div>
        {/each}
      </div>

      <!-- File -->
      <div
        class="native-sel-width"
        style="margin-top: 16px; margin-bottom: 16px;">
        <Selector
          id="file_type_selector"
          label={file_type_label}
          items={file_types}
          bind:value={file_type} />
      </div>

      <!-- Submit -->
      <div style="margin-top: 40px; text-align: center">
        <button
          data-cy="report"
          class="mdc-button mdc-button--raised"
          on:click|preventDefault={async () => { await submit_form() } }>
          {#if loading}
            {button_in_progress_text}
            <div class="loader" />
          {:else}{button_text}{/if}
        </button>
      </div>
    </form>

<style>
  main {
    margin-top: 3rem !important;
    padding: 2rem 1rem;
    background: #fff;
    border-radius: 10px;
    box-shadow: var(--global-box-shadow);
  }

  p {
    margin: 0;
    padding-top: 20px;
    padding-left: 15px;
  }

  select {
    display: block;
    font-size: 1em;
    font-family: 'Open Sans', sans-serif;
    font-weight: 300;
    line-height: 1.5;
    padding: 0.4em 3.5em 0.3em 0.8em;
    /* width: 10em; */
    max-width: 100%;
    box-sizing: border-box;
    margin: 0;
    border-radius: 0.3em;
    -moz-appearance: none;
    -webkit-appearance: none;
    appearance: none;
    background-color: white;
    background-image: linear-gradient(45deg, transparent 50%, grey 50%),
      linear-gradient(135deg, grey 50%, transparent 50%),
      linear-gradient(to right, grey, grey);
    background-position: calc(100% - 20px) 1em, calc(100% - 15px) 1em,
      calc(100% - 2.5em) 0.3em;
    background-size: 5px 5px, 5px 5px, 1px 1.5em;
    background-repeat: no-repeat;
  }

  select::-ms-expand {
    display: none;
  }

  select:hover {
    border-color: #888;
  }

  select:focus {
    outline: 0;
  }

  select option {
    font-weight: normal;
  }

  .reports-form {
    padding: 0px 40px 25px 40px;
  }

  .mdc-style-input {
    border: 1px solid #aaa;
    padding: 0 0.8em;
    border-radius: 0.3em;
    color: #767676;
    font-weight: 300;
    line-height: 3.4;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
  }

  .mdc-floating-label2 {
    font-family: Roboto, sans-serif;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-size: 0.81rem;
    color: #767676;
    line-height: 1.75rem;
    font-weight: 400;
    letter-spacing: 0.009375em;
    position: absolute;
    left: 13px;
    margin-top: -14px;
    /*margin-left: 13px;*/
    background-color: white;
  }

  .loader {
    display: inline-block;
    font-size: 10px;
    margin: 0 1em -2px;
    text-indent: -9999em;
    width: 1.5em;
    height: 1.5em;
    border-radius: 50%;
    background: #ffffff;
    background: -moz-linear-gradient(
      left,
      #ffffff 10%,
      rgba(255, 255, 255, 0) 42%
    );
    background: -webkit-linear-gradient(
      left,
      #ffffff 10%,
      rgba(255, 255, 255, 0) 42%
    );
    background: -o-linear-gradient(
      left,
      #ffffff 10%,
      rgba(255, 255, 255, 0) 42%
    );
    background: -ms-linear-gradient(
      left,
      #ffffff 10%,
      rgba(255, 255, 255, 0) 42%
    );
    background: linear-gradient(
      to right,
      #ffffff 10%,
      rgba(255, 255, 255, 0) 42%
    );
    position: relative;
    -webkit-animation: load3 1.4s infinite linear;
    animation: load3 1.4s infinite linear;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
  }
  .loader:before {
    width: 50%;
    height: 50%;
    background: #ffffff;
    border-radius: 100% 0 0 0;
    position: absolute;
    top: 0;
    left: 0;
    content: '';
  }
  .loader:after {
    background: #007bff;
    width: 75%;
    height: 75%;
    border-radius: 50%;
    content: '';
    margin: auto;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
  @-webkit-keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load3 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }

  .checkbox-label {
    text-align: left;
    left: 24px;
    position: relative;
    top: 9px;
    color: #2f2f2f;
  }

  .mdc-style-input:focus {
    box-shadow: 0 0 0 2px #069;
    outline: none !important;
    border: 1px solid transparent;
    /*box-shadow: 0 0 10px #719ECE;*/
  }

  /* Desktop Mode
    *******************************************************/
  @media (min-width: 1025px) {
    .native-sel-width {
      width: 100% !important;
    }

    .wrapper {
      width: 600px;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Tablet Mode
    *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    .native-sel-width {
      width: 100% !important;
    }
    .wrapper {
      width: 90%;
      margin: 0 auto;
      margin-bottom: 50px;
      height: fit-content;
    }
  }

  /* Mobile Mode
    *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .native-sel-width {
      width: 100% !important;
    }

    .wrapper {
      /*width: 100%;*/
      margin: 0 auto;
      margin-left: 50px;
      margin-bottom: 50px;
      height: fit-content;
    }

    /* todo: Something hijacks this input's look on mobile, so these are hacks that fixes it on Galaxy 4 */
    .mdc-style-input {
      border: 1px solid #aaa;
      padding: 0 0.8em;
      border-radius: 0.3em;
      color: #767676;
      font-weight: 300;
      line-height: 3.4;
      font-family: 'Open Sans', sans-serif;
      font-size: 16px;
      background: white;
      height: 54px;
    }

    .mdc-floating-label2 {
      /*margin-top: -69px;*/
    }

    #for-mobile-input {
      margin-top: 11px;
    }
  }
</style>
